import { ref } from '@vue/reactivity';
import { onMounted } from '@vue/runtime-core';
export default {
  name: "GoTop",
  setup() {
    const isShow = ref(false);
    const goTop = () => {
      $("html, body").animate({
        scrollTop: 0
      }, "slow");
    };
    const handleScroll = _.debounce(() => {
      isShow.value = window.scrollY > 800;
    }, 300);
    onMounted(() => {
      window.addEventListener("scroll", handleScroll);
    });
    return {
      isShow,
      goTop
    };
  }
};